import { createSlice } from '@reduxjs/toolkit'
import { RootState } from "../../store";
import { IChapterData } from "functions/Chapters";


export interface ChapterState {
    value: IChapterData[] | undefined
}

const initialState: ChapterState = {
    value: undefined
}

export const chaptersSlice = createSlice({
    name: 'chapters',
    initialState,
    reducers: {
        initChapters: (state, action) => {
            state.value = action.payload
        }
    }
})

export const { initChapters } = chaptersSlice.actions;
export const chapterStoreValue = (state: RootState) => state.chapters.value;

export default chaptersSlice.reducer
